const _expand = (k, v, o) => {
    const match = /^\.?(?:\[(\d+)\]|([a-z_]+))(.*)$/i.exec(k);
    if (match) {
        return match[3] ? Object.assign(Object.assign({}, o), { [match[1] || match[2]]: _expand(match[3], v, (o[match[1] || match[2]] || {})) }) : Object.assign(Object.assign({}, o), { [match[1] || match[2]]: (o[match[1] || match[2]] || []).concat([v]) });
    }
    console.error(`_expand - unmatched: ${k}`);
    return o;
};
export const expand = (errors) => {
    return errors.reduce(([root, expanded], { field, message }) => {
        return field === '_' ? [root.concat([message]), expanded] : [root, _expand(field, message, expanded)];
    }, [[], {}]);
};
